import {
  DamagedItemReturnDetailsExceptionSchema,
  ItemNotReceivedReturnDetailsExceptionSchema,
  ReturnExceptionSchema,
  UndeclaredItemReturnDetailsExceptionSchema,
} from "@redotech/returnbear-model/return-case";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getReturnBearExceptions = {
  name: "getReturnBearExceptions" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ exceptions: z.array(ReturnExceptionSchema) }),
};

export type GetReturnBearException = z.infer<typeof ReturnExceptionSchema>;

export type DamagedItemReturnDetailsException = z.infer<
  typeof DamagedItemReturnDetailsExceptionSchema
>;

export type ItemNotReceivedReturnDetailsException = z.infer<
  typeof ItemNotReceivedReturnDetailsExceptionSchema
>;

export type UndeclaredItemReturnDetailsException = z.infer<
  typeof UndeclaredItemReturnDetailsExceptionSchema
>;
